import { useQuery } from "@apollo/client";
import { GET_ESTABLISHMENT } from "../graphQl/EstablishmentAPI";

// Lecture d'un établissement seul. La liste des établissements n'est plus
// demandée ici : elle vit dans AdminProvider (useAdmin().establishments).
export const useEstablishmentData = (establishmentId = null) => {
  const { data, loading, error, refetch } = useQuery(GET_ESTABLISHMENT, {
    variables: { establishmentId },
    skip: !establishmentId,
    fetchPolicy: "cache-and-network",
  });

  return {
    establishment: data?.QR_GET_ESTABLISHMENT?.data || null,
    loading,
    error,
    refetchSingle: refetch,
  };
};
